import type { TelegramProductContactsDto } from '@/generated';

export type PhoneNumberFormats = {
  localPhoneNumber?: string | null;
  globalPhoneNumber?: string | null;
  phoneNumber?: string | null;
};

const contactsToPhoneFormats = (contacts?: TelegramProductContactsDto | null): PhoneNumberFormats => ({
  localPhoneNumber: contacts?.localPhoneNumber,
  globalPhoneNumber: contacts?.globalPhoneNumber,
  phoneNumber: contacts?.phoneNumbers?.[0],
});

export const renderGlobalPhoneNumber = (num: string | null | undefined) => {
  if (!num) {
    return '';
  }

  if (num.startsWith('+')) {
    return num;
  }

  return `+${num}`;
};

export const renderLocalPhoneNumber = (formats?: PhoneNumberFormats | null) => {
  return formats?.localPhoneNumber ?? formats?.phoneNumber ?? '';
};

export const getDialPhoneNumber = (formats?: PhoneNumberFormats | null) => {
  return renderGlobalPhoneNumber(formats?.globalPhoneNumber ?? formats?.phoneNumber);
};

export const getProductContactsDisplayPhoneNumber = (contacts?: TelegramProductContactsDto | null) => {
  return renderLocalPhoneNumber(contactsToPhoneFormats(contacts));
};

export const getProductContactsDialPhoneNumber = (contacts?: TelegramProductContactsDto | null) => {
  return getDialPhoneNumber(contactsToPhoneFormats(contacts));
};
